// ACTION CREATOR SET_LOADING_FOOTER
export const SET_LOADING_FOOTER = 'SET_LOADING_FOOTER';

// ACTION CREATOR setLoadingFooter
export const setLoadingFooter = (value) => ({
  type: SET_LOADING_FOOTER,
  value,
});

// ACTION CREATOR FETCH_FOOTER
export const FETCH_FOOTER = 'FETCH_FOOTER';

// ACTION CREATOR fetchFooter
export const fetchFooter = (value, backend) => ({
  type: FETCH_FOOTER,
  value,
  backend,
});

// ACTION CREATOR SET_SAVE_DATA_FOOTER
export const SET_SAVE_DATA_FOOTER = 'SET_SAVE_DATA_FOOTER';

// ACTION CREATOR setSaveDataFooter
export const setSaveDataFooter = (value) => ({
  type: SET_SAVE_DATA_FOOTER,
  value,
});
